import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { is } from 'immutable';
import ReduxRecord from './reduxRecord';
import { TEMPORARY_STIMULUS_ID } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
import { rule } from 'instructure-validations';
import { presenceMessage } from '@instructure/quiz-interactions';
export var Stimulus = /*#__PURE__*/function (_ReduxRecord) {
  function Stimulus() {
    _classCallCheck(this, Stimulus);
    return _callSuper(this, Stimulus, arguments);
  }
  _inherits(Stimulus, _ReduxRecord);
  return _createClass(Stimulus, [{
    key: "isStimulus",
    get: function get() {
      return true;
    }
  }, {
    key: "isPassage",
    get: function get() {
      return this.passage;
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return this.id !== '0';
    }
  }, {
    key: "isTemporary",
    value: function isTemporary() {
      return this.id === TEMPORARY_STIMULUS_ID;
    }
  }, {
    key: "hasModifications",
    value: function hasModifications() {
      return !is(this.getWorkingInstance(), this);
    }
  }, {
    key: "getWorkingInstance",
    value: function getWorkingInstance() {
      // The record created by .merge() somehow bypasses calling the constructor where
      // methods created by the `() => {` pattern get created/set. So we feed the result
      // through the constructor manually.
      return Stimulus.create(this.merge(this.getState().getIn(['modifications', 'stimuli', this.id])));
    }
  }, {
    key: "isImmutable",
    value: function isImmutable() {
      return this.status === 'immutable';
    }
  }], [{
    key: "validations",
    value: function validations() {
      return {
        title: [rule('presence', {
          message: presenceMessage(t('Title'))
        })],
        body: [rule('presence', {
          message: presenceMessage(t('Content'))
        })],
        onSelf: [rule('maxContent')]
      };
    }
  }]);
}(ReduxRecord({
  id: '0',
  stimulusType: 'text',
  title: '',
  instructions: '',
  body: '',
  sourceUrl: '',
  status: 'mutable',
  orientation: 'left',
  passage: false
}));
export default Stimulus;